import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
import { SharedHttp } from "../../../../services/http-client.service";
let UnstakeComponent = class UnstakeComponent {
    constructor(sanitizer, location, themeService, httpClient) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.acceptConditions = false;
        this.buttonClicked = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    unstake() {
        if (!this.acceptConditions) {
            return;
        }
        this.buttonClicked = true;
        this.httpClient.post('staking/unstake', { stakeId: this.data.stakeId }).subscribe(() => {
            this.success();
            this.close();
        }, () => {
            this.buttonClicked = false;
        });
    }
};
UnstakeComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: SharedHttp }
];
UnstakeComponent = __decorate([
    Component({
        selector: 'ecd-unstake',
        template: __importDefault(require("./unstake.component.html")).default
    })
], UnstakeComponent);
export { UnstakeComponent };
